import React, { useState } from "react";
import { login } from "./api/auth";

function Login({ onLogin }) {
  const [username, setUsername] =
    useState("");

  const [password, setPassword] =
    useState("");

  const [error, setError] =
    useState("");
const handleLogin = async () => {
  try {
    const res = await login(username, password);

    const userData = res.data.user;

    console.log("LOGIN RESPONSE:", userData);

    // 🚨 Normalize user (IMPORTANT FIX)
    const fixedUser = {
      username: userData?.username,
      role: userData?.role || "student" // fallback prevents undefined
    };

    localStorage.setItem("user", JSON.stringify(fixedUser));
    onLogin(fixedUser);
  } catch (err) {
    console.error(err);
    setError("Invalid credentials");
  }
};
  return (
    <div
      style={{
        width: "400px",
        margin: "100px auto",
        padding: "20px",
        border: "1px solid #ddd"
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
  <img
    src="/logo.png"
    alt="Company Logo"
    style={{ height: "45px" }}
  />

  <h2 style={{ color: "#0b2e6b", margin: 0 }}>
    U2UInnovation
  </h2>
  <h2 style={{ color: "#0b2e6b", margin: 0 }}>
    U2UTechnology Exploration Platform
  </h2>
</div>  
<h3>Join U2UTechXplore Platform</h3>
      <h4>To Join U2U Programs and Internships</h4>
            <h4 style={{ color: "#0b2e6b", margin: 0 }}>   --- Email us : vishruthi@u2usystems.com</h4>
<br></br>
<h3>Login</h3>
      <input
        placeholder="Username"
        value={username}
        onChange={e =>
          setUsername(e.target.value)
        }
        style={{
          width: "100%",
          marginBottom: "10px"
        }}
      />

      <input
        type="password"
        placeholder="Password"
        value={password}
        onChange={e =>
          setPassword(e.target.value)
        }
        style={{
          width: "100%",
          marginBottom: "10px"
        }}
      />

      <button onClick={handleLogin}>
        Login
      </button>

      {error && (
        <p style={{ color: "red" }}>
          {error}
        </p>
      )}
    </div>
  );
}

export default Login;